import React, { useState } from "react";
import { Dropdown } from "../../components/ui/Dropdown";

export const Dims = ({
  title,
  dims,
  setNextStep,
  isActive,
  setActiveProduct,
  activeProduct,
  setPrice,
  setLegPrice,
}) => {
  const [length, setLength] = useState(null);
  const [width, setWidth] = useState(null);
  const [diameter, setDiameter] = useState(null);

  const handleSetLength = (value) => {
    setLength(value);
    setActiveProduct((prev) => ({
      name: prev.name,
      oblik: prev.oblik,
      dims: {
        ...prev.dims,
        length: {
          name: `Dužina stola: ${value.number}`,
          value: value.number,
        },
      },
    }));
    setPrice(0);
    setLegPrice(0);
  };
  const handleSetWidth = (value) => {
    setWidth(value);
    setActiveProduct((prev) => ({
      name: prev.name,
      oblik: prev.oblik,
      dims: {
        ...prev.dims,
        width: {
          name: `Širina ploče: ${value.number}`,
          value: value.number,
        },
      },
    }));
    setPrice(0);
    setLegPrice(0);
  };

  const handleSetDiameter = (value) => {
    setDiameter(value);
    setActiveProduct((prev) => ({
      name: prev.name,
      oblik: prev.oblik,
      dims: {
        ...prev.dims,
        diameter: {
          name: `Prečnik ploče: ${value.number}`,
          value: value.number,
        },
      },
    }));
    setPrice(0);
    setLegPrice(0);
  };

  return (
    dims &&
    isActive && (
      <div class="configurator-dims-full">
        <h2 class="marcellus-40-400">{title}</h2>
        <div class="configurator-dims-full__items poppins-18-500">
          {activeProduct.oblik == "Krug" ? (
            <Dropdown
              heading={"Prečnik stola"}
              items={dims.diameter}
              setActiveItem={handleSetDiameter}
              activeItem={diameter}
              keyValue="number"
              displayTitle={true}
              style={{ zIndex: 2 }}
            />
          ) : (
            <>
              <Dropdown
                heading={"Dužina stola"}
                items={dims.length}
                setActiveItem={handleSetLength}
                activeItem={length}
                keyValue="number"
                displayTitle={true}
                style={{ zIndex: 2 }}
              />
              <Dropdown
                heading={"Širina ploče"}
                items={dims.width}
                setActiveItem={handleSetWidth}
                activeItem={width}
                keyValue="number"
                displayTitle={true}
              />
            </>
          )}
        </div>
        {((length && width) || diameter) && (
          <button
            onClick={() => {
              setNextStep();
            }}
            type="button"
            class="configurator-dims-full__btn btn green"
          >
            Nastavi
          </button>
        )}
      </div>
    )
  );
};
